module.exports = __webpack_public_path__ + "static/cercazone_sudovest3-d2932285384217b460487e4d612343a8.jpg";